import React from "react";
import "./ConfirmationBox.css";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { closeModal } from "../../../redux/modal/modalActions";
import Button from "../button/Button";

function ConfirmationBox({
  msg,
  saveAction,
  saveText,
  discardText,
  saveBtnClass,
  discardBtnClass,
}) {
  const dispatch = useDispatch();

  return (
    <div className="confirmation-container">
      <div className="confirmation-msg">{msg}</div>
      <div className="confirmation-actions">
        <Button
          className={`save-btn ${saveBtnClass}`}
          onClick={() => {
            saveAction();
            dispatch(closeModal());
          }}
          buttonText={saveText}
        />
        <Button
          className={`close-btn ${discardBtnClass}`}
          onClick={() => {
            dispatch(closeModal());
          }}
          customStyles={{ margin: "0 0 0 5px" }}
          buttonText={discardText}
        />
      </div>
    </div>
  );
}

ConfirmationBox.propTypes = {
  msg: PropTypes.string,
  saveBtnClass: PropTypes.string,
  discardBtnClass: PropTypes.string,
  saveText: PropTypes.string,
  discardText: PropTypes.string,
  saveAction: PropTypes.func,
};

ConfirmationBox.defaultProps = {
  msg: "",
  saveText: "OK",
  discardText: "Cancel",
  saveBtnClass: "",
  discardBtnClass: "",
  saveAction: () => {},
};

export default ConfirmationBox;
